import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../layouts/se.layout.widget.abstract";
import { Layouts } from "../layouts/se.layouts";
import { SeOrgSecurityStore } from "../se.org.security.store";
import { ManageAttendanceComponent } from "../attendance/se.manage.attendance.component";
import { SeAttendanceStore } from "../attendance/se.attendance.store";
import { SEEventDetailsStore } from "./se.event.details.store";

@Component({
    standalone: true,
    selector: "s25-ng-se-event-details-attendance-widget",
    template: `
        @if (orgSecStore.canViewAttendees() && attendanceStore.attendees()?.length) {
            <s25-ng-manage-attendees [occurrences]="eventStore.occurrences()" />
        }
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ManageAttendanceComponent],
})
export class SeEventDetailsAttendanceWidgetComponent extends LayoutWidget<
    typeof SeEventDetailsAttendanceWidgetComponent
> {
    static readonly META = {
        name: "Attendees",
        info: "Lists attendees when attendee data exists and your role can view attendees",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected eventStore = inject(SEEventDetailsStore);
    protected orgSecStore = inject(SeOrgSecurityStore);
    public attendanceStore = inject(SeAttendanceStore);
}
